import { useEdgeGroups } from '@/react/edge/edge-groups/queries/useEdgeGroups';

import {
  DeploymentType,
  DEPLOYMENT_TYPE_ENVIRONMENT_TYPE,
} from '../../detectDeploymentType';

export function useEdgeGroupsForDeploymentType(deploymentType: DeploymentType) {
  const environmentType = DEPLOYMENT_TYPE_ENVIRONMENT_TYPE[deploymentType];
  const edgeGroupsQuery = useEdgeGroups({ summarize: true });

  return {
    ...edgeGroupsQuery,
    // groups mixing environment types (e.g. docker + kubernetes) can't be
    // deployed to by a single edge stack, so they're not valid targets here
    data: edgeGroupsQuery.data?.filter(
      (group) =>
        group.EndpointTypes.length === 1 &&
        group.EndpointTypes.includes(environmentType)
    ),
    hasAnyEdgeGroups: !!edgeGroupsQuery.data?.length,
  };
}
